<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('common.text00124') }}</div>
    <div slot="body" style="height:400px;overflow-y:auto">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item prop="key_list" v-bind="formItemLayout2">
          <a-form-model-item v-for="(item,index) in form.key_list" :key="index" :label="`${$t('common_743')}${index+1}`">
            <div class="d-flex">
              <div class="flex-fill">
                <!-- <a-input v-model="form.key_list[index]" :placeholder="$t('common.tips.input', [$t('iamee.level_desc')])" /> -->
                <base-select
                  v-model="form.key_list[index]"
                  id-key="key"
                  name-key="label"
                  @change="v => change(v, index)"
                  :options="keysOpts"
                  :select-props="{ allowClear: true, placeholder: $t('common_742') }"
                  :disabled="index<originLevel" />
              </div>
              <a-button v-if="index>=originLevel" style="flex: 0 0 24px;margin-left: 20px;transform:translateY(8px)" shape="circle" icon="minus" size="small" @click="deleteKey(index)" />
              <div v-else style="flex: 0 0 24px;margin-left: 20px;" />
            </div>
          </a-form-model-item>
        </a-form-model-item>
      </a-form-model>
      <!-- 添加 -->
      <div class="d-flex align-items-center">
        <a-button type="primary" shape="circle" icon="plus" size="small" @click="addKey" />
        <a-button type="link" @click="addKey">{{$t('common_741')}}</a-button>
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" :loading="loading" @click="handleConfirm">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'OrganizationSetLevelDialog',
  components: { },
  mixins: [DialogMixin, WindowsMixin],
  props: {},
  data () {
    const { organization = {} } = this.params
    const { keys = '', level = 0 } = organization
    const keysList = level && keys ? keys.split('/') : []
    return {
      loading: false,
      originLevel: keysList.length,
      form: {
        key_list: keysList,
      },
      rules: {
        key_list: { validator: this.keysValidator },
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      formItemLayout2: {
        wrapperCol: {
          span: 24,
        },
        labelCol: {
          span: 0,
        },
      },
      keysOpts: [],
      disabledList: [],
    }
  },
  computed: {
  },
  created () {
    this.tM = new this.$Manager('projects', 'v1')
    this.$oM = new this.$Manager('organizations')
    this.initKeys()
  },
  methods: {
    async initKeys () {
      try {
        this.loading = true
        const { data: tags } = await this.tM.get({
          id: 'tag-value-pairs',
          params: {
            limit: 0,
            scope: this.$store.getters.scope,
            with_user_meta: true,
            key_only: true,
          },
        })
        this.keysOpts = tags.map(item => {
          return {
            label: `${item.key.replace('user:', '')} (${item.count})`,
            count: item.count,
            key: item.key.replace('user:', ''),
          }
        }).sort((a, b) => {
          return b.count - a.count
        })
        // const defaultKeysList = this.projectTreeTags.map(item => {
        //   return item.key
        // })
        // this.keysOpts = defaultKeysList.length ? defaultKeysList : [undefined]
        // this.updateDisabledItems()
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    keysValidator (rule, value, callback) {
      const isEmpty = value.some(key => !(key.trim()))
      if (isEmpty) {
        callback(new Error(this.$t('iamee.level_desc_empty_tip')))
      }
      callback()
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        const keys = []
        this.form.key_list.map((key, index) => {
          if (index >= this.originLevel) {
            keys.push(key)
          }
        })
        await this.$oM.performAction({
          id: this.params.organization.id,
          action: 'add-level',
          data: {
            key: keys,
          },
        })
        this.params.success()
        this.cancelDialog()
      } finally {
        this.loading = false
      }
    },
    change (val, index) {
      this.form.key_list[index] = val
    },
    addKey () {
      this.form.key_list = this.form.key_list.concat([''])
    },
    deleteKey (index) {
      this.form.key_list = this.form.key_list.filter((item, idx) => index !== idx)
    },
  },
}
</script>
<style lang="less" scoped>
.loading {
  display: flex;
  justify-content: center;
  padding-top: 30px;
}
</style>
